<nav class="bottom-nav" aria-label="Bottom navigation">
  <a
    *ngFor="let item of navItems; trackBy: trackByNavItem"
    class="nav-item"
    [class.active]="isActive(item)"
    [attr.href]="item.route"
    (click)="handleNavItem($event, item)"
  >
    <span class="nav-icon-wrapper">
      <i class="pi" [ngClass]="item.icon" aria-hidden="true"></i>
      <span class="cart-badge" *ngIf="item.id === 'cart' && ((cartCount$ | async) || 0) > 0">
        {{ (cartCount$ | async) || 0 }}
      </span>
    </span>
    <span>{{ item.label }}</span>
  </a>
</nav>
